import React from 'react'

import { connect } from 'react-redux'

import ClockingType from 'infra/ClockingType'

class PinHint extends React.Component {

  constructor(props) {
    super(props)
    this.state = {}
  }

  getTimeForClockingExtended = (times, workerId, clockingType) => {
    const extendedInfo = this.props.eventInfo.extendedInfo && this.props.eventInfo.extendedInfo.modules
    if (extendedInfo
        && extendedInfo[clockingType]
        && extendedInfo[clockingType][this.props.dateStr]) {
      const { timeIn, timeOut } = extendedInfo[clockingType][this.props.dateStr]
      times.timeIn = timeIn
      times.timeOut = timeOut
    }
  }

  getTimeForClockingWorker = (times, workerId, clockingType) => {
    const extendedInfo = this.props.eventInfo.extendedInfo && this.props.eventInfo.extendedInfo.modules
    if (extendedInfo
        && extendedInfo[clockingType]
        && extendedInfo[clockingType][this.props.dateStr]
        && extendedInfo[clockingType][this.props.dateStr][workerId]) {
      const  { timeIn, timeOut } =  extendedInfo[clockingType][this.props.dateStr][workerId]
      times.timeIn = timeIn
      times.timeOut = timeOut
    }
  }

  getTimeInfo = workerId => {
    let times = {}
    const { clockData } = this.props
    if (clockData) {
      switch (clockData.type) {
        case ClockingType.CLOCKING_EXTENDED:
          this.getTimeForClockingExtended(times, workerId, clockData.type)
          break
        case ClockingType.CLOCKING_LINE_ITEMS:
        case ClockingType.CLOCKING_WORKER:
          this.getTimeForClockingWorker(times, workerId, clockData.type)
          break
        default:
          times = { timeIn: '', timeOut: '' }
          break
      }
    }
    if (!times.timeIn){
      return 'Not Started'
    } else if (!times.timeOut) {
      return `${times.timeIn} - In Progress`
    } else {
      return `${times.timeIn} - ${times.timeOut}`
    }
  }

  getEventSummary = () => {
    const result = []
    const { teamMembers, eventInfo} = this.props
    const commonInfo = eventInfo.commonInfo && eventInfo.commonInfo.modules
    if (commonInfo.workers.list){
      Object.values(commonInfo.workers.list).forEach(worker => {
        const teamMember = teamMembers.find((memberTeam) => memberTeam.userId === worker.id)
        if (teamMember){
          result.push(
            <div
              key={worker.id}
              style={styles.memberContainer}>
              <span style={styles.memberDisplayName}>
                { teamMember.displayName }
              </span>
              <span style={styles.memberTime}>
                { this.getTimeInfo(worker.id) }
              </span>
            </div>
          )
        }
      })
    }
    return (
      <div
        style={styles.membersContainer}>
        {result}
      </div>
    )
  }

  render() {
    const commonInfo = this.props.eventInfo.commonInfo.modules
    return (
      <div style={styles.hintContainer}>
        <b>{ commonInfo.displayName.value }</b>
        <br/>
        <span>{ commonInfo.address.value }</span>
        <br/><br/>
        { this.getEventSummary() }
      </div>
    )
  }
}

const styles = {
  hintContainer: {
    textAlign:'left',
    flex: 1,
    width: 176,
    backgroundColor: 'white',
    opacity: 0.75,
    padding: 8,
    borderRadius: 3,
    boxShadow: '0 2px 5px 0 rgba(55, 55, 55, 0.22)',
    border: 'solid 1px #9b9b9b',
    position: 'absolute',
    zIndex: 2
  },
  membersContainer: {
    display: 'flex',
    flexDirection: 'column'
  },
  memberDisplayName: {
    display: 'flex',
    flexGrow: 1,
    justifyContent: 'flex-start'
  },
  memberTime: {
    display: 'flex',
    flexGrow: 1,
    justifyContent: 'flex-end'
  },
  memberContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  }
}

export default connect(state => ({ teamMembers: state.firebase.team.members.value }))(PinHint)



// WEBPACK FOOTER //
// ./src/schedule/map/PinHint.js